import { render, staticRenderFns } from "./prog.vue?vue&type=template&id=c4902dbe&scoped=true&"
import script from "./prog.vue?vue&type=script&lang=js&"
export * from "./prog.vue?vue&type=script&lang=js&"
import style0 from "./prog.vue?vue&type=style&index=0&id=c4902dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4902dbe",
  null
  
)

export default component.exports